var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19936 0.414821C8.65556 0.41482 8.21633 0.854047 8.21633 1.39785L8.20936 8.20935L1.39088 8.20935C0.84708 8.20935 0.407853 8.64858 0.407853 9.19238C0.407853 9.73619 0.84708 10.1754 1.39088 10.1754L8.20936 10.1754L8.20936 16.9939C8.20936 17.5377 8.64858 17.9769 9.19239 17.9769C9.73619 17.9769 10.1754 17.5377 10.1754 16.9939L10.1754 10.1754L16.9939 10.1754C17.5377 10.1754 17.9769 9.73619 17.9769 9.19238C17.9769 8.64858 17.5377 8.20935 16.9939 8.20935L10.1754 8.20935L10.1754 1.39088C10.1754 0.861019 9.72922 0.41482 9.19936 0.414821Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8d4ed6549eedb724058db58bc314ed54.svg";
export { ForwardRef as ReactComponent };